import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { PageViewModel } from '@components/ui/table-template/models/page-view-model';
import { RelatedPartyViewModel } from '../view-models/related-party-view.model';

@Component({
    selector: 'app-related-party-card',
    templateUrl: './related-party-card.component.html',
    styleUrls: ['./related-party-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AngularSvgIconModule]
})
export class RelatedPartyCardComponent {
  public readonly currentPage = input<PageViewModel<RelatedPartyViewModel>>();
}
